import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const systemListGet = () =>
    axios.get(`${apiUrl}systemLists`);

export const systemListItemGet = (listId, includeInactive) =>
    axios.get(`${apiUrl}systemLists/${listId}/items?includeInactive=${includeInactive}`);

export const systemListItemInsert = (listId, data) =>
    axios.post(`${apiUrl}systemLists/${listId}/items`, data);

export const systemListItemUpdate = (listId, itemId, data) =>
    axios.put(`${apiUrl}systemLists/${listId}/items/${itemId}`, data);
